// Name validation - Unicode letters, spaces, hyphens, apostrophes, periods, commas (regular and full-width)
export const REGEX_NAME = /^[\p{L}\p{M}\s\-'.\u2019,\uFF0C]+$/u;

// Password validation - requires uppercase, lowercase, digit, special char, min 8 chars
export const REGEX_PASSWORD =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,}$/;

// NRIC/FIN/Passport - exactly 4 alphanumeric characters
export const REGEX_NRIC = /^[A-Za-z0-9]{4}$/;

// Date of birth - DD-MM-YYYY format
export const REGEX_DOB = /^(0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;

// Date format - YYYY-MM-DD format (ISO format)
export const REGEX_DATE_ISO = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

// Mobile phone number - supports international format
export const REGEX_MOBILE = /^(\+?\d{1,3}[- ]?)?(\d{8}|\d{10})$/;

// Email address validation
export const REGEX_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// School name validation - letters, spaces, hyphens, periods, apostrophes, commas
export const REGEX_SCHOOL_NAME = /^[a-zA-Z\s\-.'`,]+$/;

// Stage of life text validation - only alphabetic characters and spaces
export const REGEX_STAGE_OF_LIFE = /^[a-zA-Z\s]+$/;

// Password rule patterns for individual checks
export const PASSWORD_RULES = {
  hasUpperCase: /[A-Z]/,
  hasLowerCase: /[a-z]/,
  hasNumber: /\d/,
  hasSymbol: /[^a-zA-Z0-9\s]/,
};

// Password minimum length constant
export const PASSWORD_MIN_LENGTH = 8;
